module.exports = __webpack_public_path__ + "static/media/medal.e9209c8b.svg";